import { Alert } from "antd";

export interface TextProps {
  value: string;
}

export const Text = ({ value }: TextProps) => {
  return <Alert type="success" message={value} showIcon />;
};
